
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_1yz9c_1tdj0_9",
  "series--bar": "awsui_series--bar_1yz9c_1tdj0_10",
  "series__rect": "awsui_series__rect_1yz9c_1tdj0_10",
  "exiting": "awsui_exiting_1yz9c_1tdj0_27",
  "awsui-motion-fade-out-0": "awsui_awsui-motion-fade-out-0_1yz9c_1tdj0_1",
  "root": "awsui_root_1yz9c_1tdj0_49",
  "series--highlighted": "awsui_series--highlighted_1yz9c_1tdj0_62",
  "series__bar--highlighted": "awsui_series__bar--highlighted_1yz9c_1tdj0_63",
  "series--dimmed": "awsui_series--dimmed_1yz9c_1tdj0_67",
  "series--threshold": "awsui_series--threshold_1yz9c_1tdj0_71",
  "bar-group": "awsui_bar-group_1yz9c_1tdj0_76"
};
  